import { useState, useEffect, useRef } from 'react';
import {ArrowLeft,MapPin,CheckCircle, Building,TreePine,AlertCircle,Loader,Save,Edit2,X,Calculator,TrendingUp,Users,DollarSign,Calendar, FileText,Settings,Award,Banknote,Wheat,Droplets,Home,Cable,Zap, Package, Search,Filter,Download,Eye,ChevronDown,ChevronUp,Info,RefreshCw,ChevronRight,UserCheck, Globe} from 'lucide-react';
import apiService from '../config';
import { toast } from 'react-toastify';
import { Send } from 'lucide-react';
import { useLanguage } from "../StoreContext/LanguageContext";
import SendTrackingModal from '../CommonModel/SendTrackingModal';
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';

const ConcernValuer = ({ onBack }) => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const userRole = userData?.user_role;

  const roleToAgencyMap = {
    21: "agriculture",
    23: "consulting_agent",
    24: "forest",
    14: "data_entry"
  };

  const [selectedAgency, setSelectedAgency] = useState(roleToAgencyMap[userRole] || "");

  // Data states
  const [compensationData, setCompensationData] = useState([]);
  const [loading, setLoading] = useState(false);

  // UI states
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  // Edit states
  const [editingCompensation, setEditingCompensation] = useState(false);
  const [editError, setEditError] = useState(null);

  // Current project and proposal info
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);
  const [proposalNo, setProposalNo] = useState('');

  // Inline editing states
  const [editingRowId, setEditingRowId] = useState(null);
  const [editingValues, setEditingValues] = useState({});
  const [tableData, setTableData] = useState([]);

  const [usersLao, setUsersLao] = useState([]);
  const [usersSamanvay, setUsersSamanvay] = useState([]);

  // Modal states
  const [showSendToLAOModal, setShowSendToLAOModal] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [selectedUser, setSelectedUser] = useState('');
  const [remarks, setRemarks] = useState('');
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [sendingToLAO, setSendingToLAO] = useState(false);
  const [isCompensationButtonClicked, setIsCompensationButtonClicked] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  // Document Viewer states
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const [fileUrlToView, setFileUrlToView] = useState('');
  const [isPDFToView, setIsPDFToView] = useState(false);

  const printRef = useRef(null);
  const [trackingRole, setTrackingRole] = useState('');
  const [showTrackingModal, setShowTrackingModal] = useState(false);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [onConfirmAction, setOnConfirmAction] = useState(null);
  //Digital Sign
  const { uploadStatus, uploadError, selectedSignDocument, resetSignatureState, signDocument } = useSignature();
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);

  const USER_ROLES = {
    SURVEYOR: 7,
    LAO: 3,
    DSLR: 15,
    AGENCY: 21,
    SAMANVAY: 6,
    DATA_ENTRY: 14
  };

  const [users, setUsers] = useState([]);

  const { language, translations } = useLanguage();

  const getCurrentProposalId = () => {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const proposalId = userData?.data?.default_proposal ||
      userData?.data?.proposal_id ||
      userData?.default_proposal ||
      userData?.proposal_id ||
      localStorage.getItem('currentProposalId') ||
      null;
    const finalProposalId = proposalId ? parseInt(proposalId) : null;
    return finalProposalId;
  };

  const getAgencyInfo = () => {
    const agencyMap = {
      agriculture: { label: <span>{translations[language].agriculture}</span>, icon: <Wheat className="w-5 h-5" />, color: 'text-green-600' },
      consulting_agent: { label: <span>{translations[language].Agother}</span>, icon: <Building className="w-5 h-5" />, color: 'text-blue-600' },
      forest: { label: <span>{translations[language].Forest}</span>, icon: <TreePine className="w-5 h-5" />, color: 'text-emerald-600' },
      vc: { label: <span>{translations[language].VillageCouncil}</span>, icon: <Users className="w-5 h-5" />, color: 'text-purple-600' }
    };
    return agencyMap[selectedAgency] || {};
  };

  const getVisibleColumns = () => {
    switch (selectedAgency) {
      case 'agriculture':
        return { tree: true, borewell: false, home: false, pipeline: false, tinShed: false, wire: false, well: false, otherAsset: false, farmpond: false, count: true };
      case 'forest':
        return { tree: true, borewell: false, home: false, pipeline: false, tinShed: false, wire: false, well: false, otherAsset: false, farmpond: false, count: true };
      case 'consulting_agent':
        return { tree: false, borewell: true, home: true, pipeline: true, tinShed: true, wire: true, well: true, otherAsset: true, farmpond: true };
      case 'data_entry':
        return { tree: true, borewell: true, home: true, pipeline: true, tinShed: true, wire: true, well: true, otherAsset: true, farmpond: true, count: true, crop: true, structure: true, waterBody: true, land: true };
      default:
        return { tree: true, borewell: true, home: true, pipeline: true, tinShed: true, wire: true, well: true, otherAsset: true, farmpond: true };
    }
  };

  const handleSendToLao = async () => {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId = currentProposalId;

    if (!selectedUser || !selectedDocument) {
      toast.warning('Please select a user and upload a document.');
      return;
    }

    setSendingToLAO(true);
    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarks);
      formData.append('usr_id', selectedUser);
      formData.append('document', selectedDocument);

      const response = await apiService.postTrackingCompensation(formData);

      if (response.status === 200) {
        toast.success('Successfully sent back to LAO Officer!');
        setShowSendToLAOModal(false);
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);
        setIsCompensationButtonClicked(true);
      } else {
        toast.error('Failed to send back to LAO Officer. Please try again.');
      }
    } catch (error) {
      console.error('Error sending to LAO:', error);
      toast.error('Error while sending back to LAO. Please try again.');
    } finally {
      setSendingToLAO(false);
    }
  };

  useEffect(() => {
    const fetchButtonState = async () => {
      try {
        if (currentProjectId && currentProposalId) {
          const res = await apiService.getCompensationButton(currentProjectId, currentProposalId, 'Compensation');
          if (res.status === 200 && Array.isArray(res.data) && res.data.length > 0) {
            setIsCompensationButtonClicked(true);
          }
        }
      } catch (err) {
        console.error("Error checking button state:", err);
      }
    };
    fetchButtonState();
  }, [currentProjectId, currentProposalId]);

  useEffect(() => {
    const getSelectedProjectAndProposal = () => {
      try {
        const storedProject = localStorage.getItem('selectedProject');
        if (storedProject) {
          const project = JSON.parse(storedProject);
          const projectIdFromStorage = project.id || project.project_id;
          if (projectIdFromStorage) setCurrentProjectId(projectIdFromStorage);
        }
        const proposalId = getCurrentProposalId();
        if (proposalId) setCurrentProposalId(proposalId);
      } catch (error) {
        console.error('Error reading selected project and proposal:', error);
      }
    };
    getSelectedProjectAndProposal();
    window.addEventListener('storage', getSelectedProjectAndProposal);
    return () => window.removeEventListener('storage', getSelectedProjectAndProposal);
  }, []);

  const fetchProposalNo = async () => {
    if (!currentProjectId || !currentProposalId) return;
    try {
      const result = await apiService.getProposalPublish(currentProjectId, currentProposalId);
      if (result.status === 200 && result.data) {
        const bhusampadan_no = result.data.section_11_bhusampadan_no || result.data.acquisition_proposal_no;
        setProposalNo(bhusampadan_no);
      }
    } catch (error) {
      console.error('Error fetching proposal number:', error);
    }
  };

  useEffect(() => {
    if (currentProjectId && currentProposalId) {
      fetchProposalNo();
    }
  }, [currentProjectId, currentProposalId]);

  // Load compensation data whenever project/proposal changes
  useEffect(() => {
    if (currentProjectId && currentProposalId) {
      loadCompensationData();
    }
  }, [currentProjectId, currentProposalId]);

  const loadCompensationData = async () => {
    try {
      setLoading(true);
      setError(null);

      const proposalId = currentProposalId || getCurrentProposalId();
      const response = await apiService.getAgencyCompensation(currentProjectId, proposalId);

      if (response && (response.status === 200 || response.data)) {
        let dataArray = [];
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          dataArray = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          dataArray = response.data;
        } else if (Array.isArray(response)) {
          dataArray = response;
        } else if (response.data && !Array.isArray(response.data)) {
          dataArray = [response.data];
        }

        const transformedData = transformBackendData(dataArray);

        const ownersWithAssets = transformedData.filter(owner => {
          const raw = owner.rawData || {};
          const hasArrayData = (arr) => Array.isArray(arr) && arr.length > 0;

          if (selectedAgency === 'agriculture') {
            return hasArrayData(raw.tree) && raw.tree.some(t => t.tree_type_name1 === 'फळझाडे');
          }
          if (selectedAgency === 'forest') {
            return hasArrayData(raw.tree) && raw.tree.some(t => t.tree_type_name1 === 'वनझाडे');
          }
          if (selectedAgency === 'consulting_agent' || selectedAgency === 'data_entry') {
            return (
              hasArrayData(raw.home) || hasArrayData(raw["tinshed/godown"]) ||
              hasArrayData(raw.wirefencing) || hasArrayData(raw.farmpond) ||
              hasArrayData(raw.well) || hasArrayData(raw.pipeline) ||
              hasArrayData(raw.borewell) || hasArrayData(raw.other)
            );
          }
          return (
            hasArrayData(raw.tree) || hasArrayData(raw.home) ||
            hasArrayData(raw["tinshed/godown"]) || hasArrayData(raw.wirefencing) ||
            hasArrayData(raw.farmpond) || hasArrayData(raw.well) ||
            hasArrayData(raw.pipeline) || hasArrayData(raw.borewell) || hasArrayData(raw.other)
          );
        });

        setCompensationData(ownersWithAssets);
        setTableData(ownersWithAssets);
      } else {
        setCompensationData([]);
        setError('Invalid response structure from server');
      }
    } catch (error) {
      console.error('Error loading compensation data:', error);
      setCompensationData([]);
      setError('Failed to load compensation data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const transformBackendData = (backendData) => {
    return backendData.map(item => {
      const ownerId = item.land_owner_id;

      let treeCount = parseInt(item.no_of_tree ?? 0) || 0;
      if (selectedAgency === 'agriculture') treeCount = (item.tree || []).filter(t => t.tree_type_name1 === 'फळझाडे').length;
      else if (selectedAgency === 'forest') treeCount = (item.tree || []).filter(t => t.tree_type_name1 === 'वनझाडे').length;

      let homeCount = item.home && Array.isArray(item.home) ? item.home.length : parseInt(item.no_of_home ?? 0) || 0;
      let tinShedCount = item['tinshed/godown'] && Array.isArray(item['tinshed/godown']) ? item['tinshed/godown'].length : parseInt(item.no_of_tinshed ?? 0) || 0;
      let wireCount = item.wirefencing && Array.isArray(item.wirefencing) ? item.wirefencing.length : parseInt(item.no_of_wirefencing ?? 0) || 0;
      let borewellCount = item.borewell && Array.isArray(item.borewell) ? item.borewell.length : parseInt(item.no_of_borewell ?? 0) || 0;
      let pipelineCount = item.pipeline && Array.isArray(item.pipeline) ? item.pipeline.length : parseInt(item.no_of_pipeline ?? 0) || 0;
      let otherAssetCount = item.other && Array.isArray(item.other) ? item.other.length : parseInt(item.no_of_other_asset ?? 0) || 0;
      let wellCount = item.well && Array.isArray(item.well) ? item.well.length : parseInt(item.no_of_well ?? 0) || 0;
      let farmPondCount = item.farmpond && Array.isArray(item.farmpond) ? item.farmpond.length : parseInt(item.no_of_fram_pound ?? 0) || 0;

      const structureCount = parseInt(item.no_of_structure ?? 0) || 0;
      const cropCount = parseInt(item.no_of_crop ?? 0) || 0;
      const waterBodyCount = parseInt(item.no_of_water_body ?? 0) || 0;

      const solatiumAmount = parseFloat(item.solatium_compensation_amount ?? 0) || 0;
      const interestAmount = parseFloat(item.interest_amount ?? 0) || 0;
      const additionalCompensation = parseFloat(item.additional_compensation ?? 0) || 0;
      const totalCompensation = parseFloat(item.total_compensation ?? 0) || 0;
      const acquiredAreaValue = parseFloat(item.owner_aqr_area ?? 0) || 0;
      const landValueTotal = parseFloat(item.land_amount ?? 0) || 0;

      let propertyDescriptions = [];
      const addPropertyDescriptions = (items, type) => {
        if (items && Array.isArray(items) && items.length > 0) {
          items.forEach(() => propertyDescriptions.push(`${type}`));
        }
      };
      addPropertyDescriptions(item.borewell, translations[language].Borewelldepth || 'Borewell');
      addPropertyDescriptions(item.pipeline, translations[language].Pipelinelength || 'Pipeline');
      addPropertyDescriptions(item.home, translations[language].Homearea || 'Home');
      addPropertyDescriptions(item['tinshed/godown'], translations[language].TinShedarea || 'Tinshed');
      addPropertyDescriptions(item.wirefencing, translations[language].Wirefencingarea || 'Wirefencing');
      addPropertyDescriptions(item.well, translations[language].Wellvolume || 'Well');
      addPropertyDescriptions(item.farmpond, translations[language].Farmpondvolume || 'Farm Pond');
      if (item.other && Array.isArray(item.other)) {
        item.other.forEach(obj => propertyDescriptions.push(`${obj.construction_type || "Other"}`));
      }

      const calculateProduct = (obj) => {
        let product = 1; let hasValue = false;
        ['Property_length', 'Property_width', 'Property_depth', 'Property_height'].forEach(field => {
          const val = parseFloat(obj[field]);
          if (!isNaN(val) && obj[field] !== null) { product *= val; hasValue = true; }
        });
        return hasValue ? product : 0;
      };

      const propertyAreas = [];
      const addPropertyArea = (items, array, label) => {
        if (items && Array.isArray(items)) {
          items.forEach(item => {
            const area = calculateProduct(item);
            array.push(area !== 0 ? `${area.toFixed(2)} (${label})` : `- (${label})`);
          });
        }
      };
      addPropertyArea(item.borewell, propertyAreas, translations[language].Agmeter);
      addPropertyArea(item.pipeline, propertyAreas, translations[language].Agmeter);
      addPropertyArea(item.home, propertyAreas, translations[language].Agsquaremeter);
      addPropertyArea(item['tinshed/godown'], propertyAreas, translations[language].Agsquaremeter);
      addPropertyArea(item.wirefencing, propertyAreas, translations[language].Agsquaremeter);
      addPropertyArea(item.well, propertyAreas, translations[language].Cubicmeter);
      addPropertyArea(item.farmpond, propertyAreas, translations[language].Cubicmeter);
      if (item.other && Array.isArray(item.other)) {
        item.other.forEach(obj => propertyAreas.push(`${obj.Property_count ?? "-"}`));
      }

      const propertyYears = [], propertyActualAreas = [], propertyRemarks = [], propertyPaymentDue = [];
      let treeRemarks = [];
      if (item.tree && Array.isArray(item.tree)) {
        if (selectedAgency === "agriculture") treeRemarks = item.tree.filter(t => t.tree_type_name1 === "फळझाडे").map(t => (t.remarks && t.remarks.trim() !== "" ? t.remarks : "-"));
        else if (selectedAgency === "forest") treeRemarks = item.tree.filter(t => t.tree_type_name1 === "वनझाडे").map(t => (t.remarks && t.remarks.trim() !== "" ? t.remarks : "-"));
        else treeRemarks = item.tree.map(t => (t.remarks && t.remarks.trim() !== "" ? t.remarks : "-"));
      }

      const addPropertyYear = (items, array) => { if (items && Array.isArray(items)) items.forEach(item => array.push(item.year_of_construction || '-')); };
      const addPropertyActual = (items, array) => { if (items && Array.isArray(items)) items.forEach(item => { const area = parseFloat(item.actual_area); array.push(!isNaN(area) && item.actual_area !== null ? area.toFixed(2) : '-'); }); };
      const addPropertyRemark = (items, array) => { if (items && Array.isArray(items)) items.forEach(item => array.push(item.remarks && item.remarks.trim() !== "" ? item.remarks : "-")); };
      const addPropertyPaymentDue = (items, array) => { if (items && Array.isArray(items)) items.forEach(item => array.push(item.Property_amount_valuer && item.Property_amount_valuer.toString().trim() !== "" ? item.Property_amount_valuer : "-")); };

      [item.borewell, item.pipeline, item.home, item['tinshed/godown'], item.wirefencing, item.well, item.farmpond, item.other].forEach(arr => {
        addPropertyYear(arr, propertyYears);
        addPropertyActual(arr, propertyActualAreas);
        addPropertyRemark(arr, propertyRemarks);
        addPropertyPaymentDue(arr, propertyPaymentDue);
      });

      let landRate = 0;
      if (item.land_rate) landRate = parseFloat(item.land_rate);
      else if (landValueTotal && acquiredAreaValue > 0) landRate = landValueTotal / acquiredAreaValue;

      return {
        id: item.compensation_id || ownerId,
        compId: item.compensation_id || ownerId,
        landOwnerId: item.land_owner_id,
        owner_name: item.owner_name || 'No Owner Available',
        surveyNo: item.survey_no || 'N/A',
        rawData: item,
        acquiredArea: acquiredAreaValue,
        landRate,
        owner_aqr_area_land_rate: item.owner_aqr_area_land_rate != null ? parseFloat(item.owner_aqr_area_land_rate) : 0,
        wellCount, structureCount, treeCount, cropCount, waterBodyCount, borewellCount,
        homeCount, pipelineCount, tinShedCount, wireCount, otherAssetCount, farmPondCount,
        propertyDescriptions, propertyAreas, propertyYears, propertyActualAreas, propertyRemarks, propertyPaymentDue, treeRemarks,
        landCompensation: landValueTotal,
        structureCompensation: parseFloat(item.structure_amount ?? 0) || 0,
        treeCompensation: parseFloat(item.tree_amount ?? 0) || 0,
        cropCompensation: parseFloat(item.crop_amount ?? 0) || 0,
        waterBodyCompensation: parseFloat(item.water_body_amount ?? 0) || 0,
        borewellCompensation: parseFloat(item.borewell_amount ?? 0) || 0,
        homeCompensation: parseFloat(item.home_amount ?? 0) || 0,
        pipelineCompensation: parseFloat(item.pipeline_amount ?? 0) || 0,
        tinShedCompensation: parseFloat(item.tinshed_amount ?? 0) || 0,
        wireCompensation: parseFloat(item.wire_amount ?? 0) || 0,
        otherAssetCompensation: parseFloat(item.other_asset_amount ?? 0) || 0,
        wellCompensation: parseFloat(item.well_amount ?? 0) || 0,
        farmPondCompensation: parseFloat(item.farmpond_amount ?? 0) || 0,
        solatium30: solatiumAmount, interestAward: interestAmount,
        additionalCompensation, totalFinalAward: totalCompensation,
        remarks: item.remarks || '',
        compensationStatus: item.COMPENSATION_STATUS || 'Pending',
        projectId: item.project_id,
        landAcquisitionId: item.LandAcquisition_id,
        paymentDue: item.Property_amount_valuer || "",
        treeRate: parseFloat(item.no_of_tree_rate ?? 0) || 0,
        cropRate: parseFloat(item.no_of_crop_rate ?? 0) || 0,
        structureRate: parseFloat(item.no_of_structure_rate ?? 0) || 0,
        waterBodyRate: parseFloat(item.no_of_water_body_rate ?? 0) || 0,
        borewellRate: parseFloat(item.no_of_borewell_rate ?? 0) || 0,
        homeRate: parseFloat(item.no_of_home_rate ?? 0) || 0,
        pipelineRate: parseFloat(item.no_of_pipeline_rate ?? 0) || 0,
        tinShedRate: parseFloat(item.no_of_tinshed_rate ?? 0) || 0,
        wireRate: parseFloat(item.no_of_wire_rate ?? 0) || 0,
        otherAssetRate: parseFloat(item.no_of_other_asset_rate ?? 0) || 0,
        wellRate: parseFloat(item.no_of_well_rate ?? 0) || 0,
        district: item.dist_name || '',
        taluka: item.taluka_name || '',
        village: item.village_name || ''
      };
    });
  };

  const handleEditStart = (record) => {
    const measureId = record.landOwnerId;
    if (!measureId) { setError('Unable to edit this record: No LandAcquisition_id found.'); return; }
    setEditingRowId(record.id);
    setEditingValues({
      owner_aqr_area_land_rate: record.owner_aqr_area_land_rate ?? '',
      no_of_structure_rate: record.structureRate ?? '',
      no_of_tree_rate: record.treeRate ?? '',
      no_of_crop_rate: record.cropRate ?? '',
      no_of_water_body_rate: record.waterBodyRate ?? '',
      no_of_borewell_rate: record.borewellRate ?? '',
      no_of_home_rate: record.homeRate ?? '',
      no_of_tinshed_rate: record.tinShedRate ?? '',
      no_of_pipeline_rate: record.pipelineRate ?? '',
      no_of_wire_rate: record.wireRate ?? '',
      no_of_other_asset_rate: record.otherAssetRate ?? '',
      measureId
    });
    setEditError(null);
  };

  const handleEditCancel = () => { setEditingRowId(null); setEditingValues({}); setEditError(null); };

  const handleEditSave = async (record) => {
    try {
      setEditingCompensation(true); setEditError(null); setError(null);
      const measureId = editingValues.measureId;
      const measurementPayload = {
        owner_aqr_area_land_rate: parseFloat(editingValues.owner_aqr_area_land_rate) || 0,
        no_of_structure_rate: parseFloat(editingValues.no_of_structure_rate) || 0,
        no_of_tree_rate: parseFloat(editingValues.no_of_tree_rate) || 0,
        no_of_crop_rate: parseFloat(editingValues.no_of_crop_rate) || 0,
        no_of_water_body_rate: parseFloat(editingValues.no_of_water_body_rate) || 0,
        no_of_borewell_rate: parseFloat(editingValues.no_of_borewell_rate) || 0,
        no_of_home_rate: parseFloat(editingValues.no_of_home_rate) || 0,
        no_of_tinshed_rate: parseFloat(editingValues.no_of_tinshed_rate) || 0,
        no_of_pipeline_rate: parseFloat(editingValues.no_of_pipeline_rate) || 0,
        no_of_wire_rate: parseFloat(editingValues.no_of_wire_rate) || 0,
        no_of_well_rate: parseFloat(editingValues.no_of_well_rate) || 0,
        no_of_other_asset_rate: parseFloat(editingValues.no_of_other_asset_rate) || 0,
        no_of_fram_pound: parseFloat(editingValues.no_of_fram_pound) || 0,
        no_of_fram_pound_rate: parseFloat(editingValues.no_of_fram_pound_rate) || 0
      };
      const cleanPayload = Object.fromEntries(Object.entries(measurementPayload).filter(([_, value]) => value !== null && value !== 0));
      const response = await apiService.patchUpdateMeasurement(measureId, cleanPayload);
      if (response && (response.status === 200 || response.status === 204)) {
        setSuccess(true);
        setSuccessMessage(`Compensation rates updated successfully for ${record.owner_name}!`);
        setEditingRowId(null); setEditingValues({});
        await loadCompensationData();
        setTimeout(() => { setSuccess(false); setSuccessMessage(''); }, 4000);
      } else {
        throw new Error(`Invalid response from server: ${response?.status || 'Unknown'}`);
      }
    } catch (error) {
      console.error('Error updating measurement rates:', error);
      setEditError('Failed to update measurement rates: ' + error.message);
    } finally {
      setEditingCompensation(false);
    }
  };

  const fetchUserslao = async () => {
    setLoadingUsers(true);
    try {
      const response = await apiService.getAssignLAO(3, currentProjectId, currentProposalId);
      if (response.status === 200 && response.data) setUsers(Array.isArray(response.data) ? response.data : []);
    } catch (error) { setUsers([]); }
    finally { setLoadingUsers(false); }
  };

  const fetchUsersSamanvay = async () => {
    setLoadingUsers(true);
    try {
      const response = await apiService.getAllUserRoleSamanvay();
      if (response.status === 200 && response.data) setUsersSamanvay(Array.isArray(response.data) ? response.data : []);
    } catch (error) { setUsersSamanvay([]); }
    finally { setLoadingUsers(false); }
  };

  // Filter by search term
  const filteredData = compensationData.filter(record => {
    const matchesSearch =
      record.owner_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (record.landOwnerId && record.landOwnerId.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
      (record.surveyNo && record.surveyNo.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (record.district && record.district.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (record.taluka && record.taluka.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (record.village && record.village.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesSearch;
  });

  // ─── Group filteredData by village ─────────────────────────────────────────
  const groupedByVillage = filteredData.reduce((acc, record) => {
    const villageKey = record.village || 'Unknown Village';
    if (!acc[villageKey]) acc[villageKey] = [];
    acc[villageKey].push(record);
    return acc;
  }, {});
  const villageKeys = Object.keys(groupedByVillage);
  // ────────────────────────────────────────────────────────────────────────────

  const visibleColumns = getVisibleColumns();
  const agencyInfo = getAgencyInfo();

  if (loading && compensationData.length === 0) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <Loader className="h-12 w-12 animate-spin text-blue-500" />
          <p className="text-gray-600 text-lg font-medium">{translations[language].LoadingData}</p>
          <p className="text-gray-500 text-sm">{translations[language].PleaseWait}</p>
        </div>
      </div>
    );
  }

  const handleViewDocument = (urlOrFile) => {
    if (!urlOrFile) return;
    let url, isPdf;
    if (urlOrFile instanceof File) {
      url = URL.createObjectURL(urlOrFile);
      isPdf = urlOrFile.type === 'application/pdf';
    } else {
      url = urlOrFile;
      isPdf = urlOrFile.toLowerCase().includes('.pdf');
    }
    setFileUrlToView(url); setIsPDFToView(isPdf); setShowDocumentViewer(true);
  };

  const closeDocumentViewer = () => {
    setShowDocumentViewer(false);
    if (fileUrlToView.startsWith('blob:')) URL.revokeObjectURL(fileUrlToView);
    setFileUrlToView(''); setIsPDFToView(false);
  };

  const handlePrint = () => {
    const printContent = printRef.current?.innerHTML;
    if (!printContent) { alert("No content available to print."); return; }
    const agencyName = agencyInfo.label?.props?.children || 'Agency Report';
    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
      <html><head><title>Concern Valuer Report</title>
      <style>
        @page { size: A4 portrait; margin-top: 0.19in; margin-bottom: 0.25in; margin-left: 0.81in; margin-right: 0.5in; }
        body { font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif; font-size: 12px; }
        .print-header { text-align: center; }
        .print-header h2 { font-size: 16px; font-weight: bold; }
        .print-footer { margin-top: 40px; text-align: right; font-weight: bold; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th, td { border: 1px solid #333; padding: 6px; text-align: center; font-size: 11px; }
        th { background-color: #f0f0f0; font-weight: bold; }
        .village-header { background-color: #dbeafe; font-weight: bold; font-size: 13px; padding: 8px; text-align: left; }
        .no-print { display: none !important; }
      </style></head>
      <body>
        <div class="print-header">
          <h2>भूसंपादन प्रकरण क्र. ${proposalNo || 'N/A'}</h2>
          <h2>${agencyName} संस्था</h2>
        </div>
        ${printContent}
        <div class="print-footer"><p>सही/-</p><p>${agencyName} संबंधित अधिकारी</p></div>
      </body></html>
    `);
    win.document.close(); win.print();
  };

  // Column count for colSpan
  const getColSpan = () => {
    let count = 4; // action, sr, name, survey
    if (visibleColumns.tree) count += 1;
    if (visibleColumns.count) count += 1;
    if (selectedAgency === 'agriculture' || selectedAgency === 'forest' || selectedAgency === 'data_entry') count += 3;
    if (selectedAgency === 'consulting_agent' || selectedAgency === 'data_entry') count += 6;
    return count;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">

      {/* Success / Error Messages */}
      {success && (
        <div className="mx-6 mt-6 p-4 rounded-xl bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200">
          <div className="flex items-center text-green-800">
            <CheckCircle className="w-5 h-5 mr-3" />
            <span className="font-medium">{successMessage || "Operation completed successfully!"}</span>
          </div>
        </div>
      )}
      {(error || editError) && (
        <div className="mx-6 mt-6 p-4 rounded-xl bg-gradient-to-r from-red-50 to-rose-50 border border-red-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center text-red-800">
              <AlertCircle className="w-5 h-5 mr-3" />
              <span className="font-medium">{error || editError}</span>
            </div>
            <button onClick={() => { setError(null); setEditError(null); }} className="text-red-600 hover:text-red-800">
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      <div className="px-6 pb-6">

        {/* Header Panel */}
        <div className="mt-6 backdrop-blur-xl bg-white/70 rounded-2xl shadow-lg border border-white/50 overflow-hidden">
          <div className="bg-gradient-to-r from-blue-500/10 to-indigo-500/10 px-6 py-4 border-b border-gray-200/50">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">

              {/* Left: Agency badge + Print */}
              <div className="flex items-center space-x-3">
                {selectedAgency && (
                  <div className="flex items-center space-x-2 bg-white shadow-md px-4 py-2 rounded-xl w-fit">
                    {agencyInfo.icon}
                    <span className={`font-semibold ${agencyInfo.color}`}>
                      {agencyInfo.label} {translations[language].AgencySelected}
                    </span>
                  </div>
                )}
                <button
                  onClick={handlePrint}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg flex items-center transition-all duration-300 shadow-lg hover:bg-green-700"
                >
                  <span className="font-medium">{translations[language]?.Print || 'Print'}</span>
                </button>
              </div>

              {/* Right: Action buttons */}
              <div className="flex flex-wrap items-center gap-3 p-3 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
                {/* <button
                  onClick={() => { setTrackingRole('Back_LAOV'); setShowTrackingModal(true); }}
                  className="flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 bg-orange-600 text-white hover:bg-orange-700"
                >
                  <ArrowLeft className="mr-2 h-5 w-5" />
                  <span>Send back to LAO</span>
                </button> */}

                {userRole !== USER_ROLES.DATA_ENTRY && (
                  <button
                    onClick={() => {
                      fetchUserslao();
                      fetchUsersSamanvay();
                      setShowSendToLAOModal(true);
                      setIsCompensationButtonClicked(true);
                    }}
                    className={`px-4 py-2 font-semibold rounded-xl shadow-lg flex items-center transition-all duration-200 ${isCompensationButtonClicked ? "bg-red-600 text-white" : "bg-blue-600 text-white hover:bg-blue-700"}`}
                  >
                    <Send className="mr-2 h-5 w-5" />
                    <span>{translations[language].CommonSave}</span>
                  </button>
                )}

                {/* Search */}
                {/* <div className="relative">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <input
                    type="text"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    placeholder={translations[language]?.Search || "Search..."}
                    className="pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  />
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* Send to LAO Modal */}
        {/* {showSendToLAOModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].SelectLAOUser} *</label>
                    <select value={selectedUser} onChange={e => setSelectedUser(e.target.value)} disabled={loadingUsers} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
                      <option value="">{loadingUsers ? translations[language].LoadingOfficers : translations[language].SelectOfficer}</option>
                      {users.map(user => (
                        <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                          {user.full_name || user.user_name} ({user.usr_role})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].Remarks}</label>
                    <textarea value={remarks} onChange={e => setRemarks(e.target.value)} rows={3} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500" placeholder={translations[language].EnterRemarks} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].UploadDocument} *</label>
                    <input type="file" onChange={e => setSelectedDocument(e.target.files[0])} className="w-full p-3 border border-gray-300 rounded-lg" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
                  </div>
                </div>
                <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                  <button onClick={() => setShowSendToLAOModal(false)} className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50" disabled={sendingToLAO}>{translations[language].Cancel}</button>
                  <button onClick={handleSendToLao} disabled={sendingToLAO || !selectedUser || !selectedDocument} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 flex items-center">
                    {sendingToLAO ? (<><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>{translations[language].Sending}</>) : (<><Send className="mr-2 h-4 w-4" />{translations[language].CommonSave}</>)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )} */}
        {showSendToLAOModal && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].SelectLAOUser} *</label>
                        <select value={selectedUser} onChange={e => setSelectedUser(e.target.value)} disabled={loadingUsers} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
                            <option value="">{loadingUsers ? translations[language].LoadingOfficers : translations[language].SelectOfficer}</option>
                            {users.map(user => (
                                <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                    {user.full_name || user.user_name} ({user.usr_role})
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].Remarks}</label>
                        <textarea value={remarks} onChange={e => setRemarks(e.target.value)} rows={3} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500" placeholder={translations[language].EnterRemarks} />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].UploadDocument} *</label>
                        <input type="file" onChange={e => setSelectedDocument(e.target.files[0])} className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
                        
                        {/* Added Document View and Sign UI */}
                        {selectedDocument && (
                            <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                <div className="flex items-center justify-between mb-2">
                                    <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                        {translations[language]?.Selected || 'Selected'}: {selectedDocument.name}
                                    </p>
                                    <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                        {(selectedDocument.size / 1024 / 1024).toFixed(2)} MB
                                    </span>
                                </div>
                                <div className="flex gap-2">
                                    {selectedDocument.type === 'application/pdf' && (
                                        <>
                                            <button 
                                                type="button" 
                                                onClick={() => { 
                                                    if (selectedDocument?.type === 'application/pdf') { 
                                                        setPdfForSigning(selectedDocument); 
                                                        setShowSignaturePad(true); 
                                                    } 
                                                }} 
                                                disabled={uploadStatus === 'uploading'} 
                                                className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                            >
                                                {uploadStatus === 'uploading' ? (
                                                    <><div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>Signing...</>
                                                ) : (
                                                    <><svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>Sign Doc</>
                                                )}
                                            </button>
                                            <button 
                                                type="button" 
                                                onClick={() => handleViewDocument(uploadStatus === 'success' ? selectedSignDocument : selectedDocument)} 
                                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                                            >
                                                <Eye className="h-3 w-3" />
                                                {translations[language]?.View || 'View'}
                                            </button>
                                        </>
                                    )}
                                </div>
                                {uploadStatus === 'success' && (
                                    <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">✅ Document Signed Successfully</div>
                                )}
                                {uploadStatus === 'error' && uploadError && (
                                    <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">❌ {uploadError}</div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                    {/* Added cleanup to the cancel button */}
                    <button 
                        onClick={() => { 
                            setShowSendToLAOModal(false); 
                            setSelectedDocument(null); 
                            resetSignatureState(); 
                        }} 
                        className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50" 
                        disabled={sendingToLAO}
                    >
                        {translations[language].Cancel}
                    </button>
                    <button 
                        onClick={handleSendToLao} 
                        disabled={sendingToLAO || !selectedUser || !selectedDocument} 
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 flex items-center"
                    >
                        {sendingToLAO ? (
                            <><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>{translations[language].Sending}</>
                        ) : (
                            <><Send className="mr-2 h-4 w-4" />{translations[language].CommonSave}</>
                        )}
                    </button>
                </div>
            </div>
        </div>
        
        {/* Added Signature Pad component injection */}
        {showSignaturePad && pdfForSigning && (
            <SignaturePad
                pdfFile={pdfForSigning} 
                onSign={(signaturesArray) => { 
                    setShowSignaturePad(false); 
                    signDocument(pdfForSigning, signaturesArray).then(() => { 
                        setPdfForSigning(null); 
                    }); 
                }} 
                onCancel={() => { 
                    setShowSignaturePad(false); 
                    setPdfForSigning(null); 
                }} 
            />
        )}
    </div>
)}

        {/* ── Village-wise Compensation Table ─────────────────────────────── */}
        <div className="mt-6 backdrop-blur-xl bg-white/90 rounded-2xl shadow-lg border border-white/50 overflow-hidden">
          <div className="overflow-x-auto" ref={printRef}>
            <table className="w-full border-collapse min-w-[1200px]">
              <thead>
                <tr className="bg-gradient-to-r from-gray-100 to-gray-200">
                  <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-20 no-print">{translations[language].AgAction}</th>
                  <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-12">{translations[language].SrNo}</th>
                  <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language].landholderName}</th>
                  <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-20">{translations[language].AgSurveyGatNo}</th>

                  {visibleColumns.tree && (
                    <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-28">
                      {selectedAgency === "agriculture" ? <span>{translations[language].Typesoffruittrees}</span>
                        : selectedAgency === "forest" ? <span>{translations[language].Foresttype}</span>
                          : translations[language].tree}
                    </th>
                  )}
                  {visibleColumns.count && (
                    <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-28">{translations[language].Numericalcount}</th>
                  )}

                  {(selectedAgency === 'agriculture' || selectedAgency === 'forest' || selectedAgency === 'data_entry') && (
                    <>
                      <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language]?.Numberofactuals || 'Actual Count'}</th>
                      <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language]?.Compensationpayable || 'Tree Compensation'}</th>
                      <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language].Remarks || "Remarks"}</th>
                    </>
                  )}

                  {(selectedAgency === 'consulting_agent' || selectedAgency === 'data_entry') && (
                    <>
                      <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language]?.PropertyDescription}</th>
                      <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language]?.Areacalculation}</th>
                      <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language]?.Yearofconstruction}</th>
                      <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language]?.Aga}</th>
                      <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language].Paymentdue || "Payment Due"}</th>
                      <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">{translations[language].Remarks || "Remarks"}</th>
                    </>
                  )}
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={getColSpan()} className="border border-gray-400 px-6 py-12 text-center">
                      <div className="flex flex-col items-center justify-center space-y-3">
                        <Loader className="w-8 h-8 animate-spin text-blue-500" />
                        <div className="text-gray-500 font-medium">{translations[language].LoadingCompensationRecords}</div>
                      </div>
                    </td>
                  </tr>
                ) : filteredData.length === 0 ? (
                  <tr>
                    <td colSpan={getColSpan()} className="border border-gray-400 px-6 py-12 text-center">
                      <div className="flex flex-col items-center justify-center space-y-3">
                        <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
                          <FileText className="w-8 h-8 text-gray-400" />
                        </div>
                        <div className="text-gray-500 font-medium">
                          {searchTerm ? `No records found matching "${searchTerm}"` : "No compensation records found"}
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  // ── Render rows grouped by village ──────────────────────
                  villageKeys.map(villageKey => {
                    const villageRecords = groupedByVillage[villageKey];
                    let globalOwnerIndex = 0;

                    return (
                      <>
                        {/* Village Header Row */}
                        <tr key={`village-header-${villageKey}`}>
                          <td
                            colSpan={getColSpan()}
                            className="border border-gray-400 px-4 py-2 bg-blue-100 text-blue-900 font-bold text-sm"
                          >
                            <div className="flex items-center space-x-2">
                              <MapPin className="w-4 h-4 text-blue-600" />
                              <span>
                                {villageRecords[0]?.district && `${villageRecords[0].district} › `}
                                {villageRecords[0]?.taluka && `${villageRecords[0].taluka} › `}
                                {villageKey}
                              </span>
                              <span className="ml-2 text-xs font-normal text-blue-600">
                                ({villageRecords.length} {translations[language]?.Records || 'records'})
                              </span>
                            </div>
                          </td>
                        </tr>

                        {/* Owner rows for this village */}
                        {villageRecords.map((record, ownerIndex) => {
                          const numAssets =
                            (selectedAgency === 'agriculture' || selectedAgency === 'forest'
                              ? (record.rawData.tree || []).filter(t =>
                                (selectedAgency === 'agriculture' && t.tree_type_name1 === 'फळझाडे') ||
                                (selectedAgency === 'forest' && t.tree_type_name1 === 'वनझाडे')
                              ).length
                              : record.propertyDescriptions?.length) || 1;

                          return Array.from({ length: numAssets }, (_, assetIndex) => {
                            const isEditing = editingRowId === record.id;
                            const treeFiltered = (record.rawData.tree || []).filter(t =>
                              (selectedAgency === 'agriculture' && t.tree_type_name1 === 'फळझाडे') ||
                              (selectedAgency === 'forest' && t.tree_type_name1 === 'वनझाडे')
                            )[assetIndex];

                            return (
                              <tr
                                key={`${record.id}-${assetIndex}`}
                                className={`transition-colors duration-150 ${isEditing ? "bg-blue-50" : "hover:bg-gray-50"} ${ownerIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
                              >
                                {/* Actions */}
                                {assetIndex === 0 && (
                                  <td rowSpan={numAssets} className="border border-gray-400 px-2 py-2 text-center no-print">
                                    <div className="flex items-center justify-center space-x-1">
                                      {isEditing ? (
                                        <>
                                          <button onClick={() => handleEditSave(record)} disabled={editingCompensation} className="p-1.5 rounded-lg bg-green-500 hover:bg-green-600 disabled:bg-green-300 text-white" title="Save">
                                            {editingCompensation ? <Loader className="w-3 h-3 animate-spin" /> : <Save className="w-3 h-3" />}
                                          </button>
                                          <button onClick={handleEditCancel} disabled={editingCompensation} className="p-1.5 rounded-lg bg-red-500 hover:bg-red-600 text-white" title="Cancel">
                                            <X className="w-3 h-3" />
                                          </button>
                                        </>
                                      ) : (
                                        <button onClick={() => { setEditRecord(record.rawData); setShowEditModal(true); }} className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700">
                                          <Edit2 size={16} />
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                )}

                                {/* Serial Number */}
                                {assetIndex === 0 && (
                                  <td rowSpan={numAssets} className="border border-gray-400 px-2 py-2 text-center text-sm font-bold text-gray-900">
                                    {ownerIndex + 1}
                                  </td>
                                )}

                                {/* Owner Name */}
                                {assetIndex === 0 && (
                                  <td rowSpan={numAssets} className="border border-gray-400 px-3 py-2 text-sm text-center">
                                    {record.owner_name}
                                  </td>
                                )}

                                {/* Survey No */}
                                {assetIndex === 0 && (
                                  <td rowSpan={numAssets} className="border border-gray-400 px-2 py-2 text-center">
                                    <div className="text-sm text-blue-600">{record.surveyNo}</div>
                                  </td>
                                )}

                                {/* Tree Type */}
                                {visibleColumns.tree && (
                                  <td className="border border-gray-400 py-2 text-center">
                                    {treeFiltered ? <span className="font-medium text-gray-700">{treeFiltered.tree_type_name}</span> : <span className="text-gray-500">-</span>}
                                  </td>
                                )}

                                {/* Numerical Count */}
                                {visibleColumns.count && (
                                  <td className="border border-gray-400 py-2 text-center">
                                    {treeFiltered ? <span className="text-gray-900">{treeFiltered.tree_count}</span> : <span className="text-gray-500">-</span>}
                                  </td>
                                )}

                                {/* Agriculture / Forest columns */}
                                {(selectedAgency === 'agriculture' || selectedAgency === 'forest' || selectedAgency === 'data_entry') && (
                                  <>
                                    <td className="border border-gray-400 py-2 text-center">
                                      {treeFiltered ? (parseFloat(treeFiltered.tree_value_valuer) || 0).toLocaleString() : <span className="text-gray-500">-</span>}
                                    </td>
                                    <td className="border border-gray-400 py-2 text-center">
                                      {treeFiltered ? `₹${(parseFloat(treeFiltered.tree_amount_valuer) || 0).toLocaleString()}` : <span className="text-gray-500">-</span>}
                                    </td>
                                    <td className="border border-gray-400 py-2 text-center">
                                      {treeFiltered && record.treeRemarks[assetIndex] ? record.treeRemarks[assetIndex] : <span className="text-gray-500">-</span>}
                                    </td>
                                  </>
                                )}

                                {/* Consulting Agent columns */}
                                {(selectedAgency === 'consulting_agent' || selectedAgency === 'data_entry') && (
                                  <>
                                    <td className="border border-gray-400 py-2 text-center">{record.propertyDescriptions[assetIndex] || <span className="text-gray-500">-</span>}</td>
                                    <td className="border border-gray-400 py-2 text-center">{record.propertyAreas[assetIndex] || <span className="text-gray-500">-</span>}</td>
                                    <td className="border border-gray-400 py-2 text-center">{record.propertyYears[assetIndex] || <span className="text-gray-500">-</span>}</td>
                                    <td className="border border-gray-400 py-2 text-center">{record.propertyActualAreas[assetIndex] || <span className="text-gray-500">-</span>}</td>
                                    <td className="border border-gray-400 py-2 text-center">{record.propertyPaymentDue[assetIndex] || <span className="text-gray-500">-</span>}</td>
                                    <td className="border border-gray-400 py-2 text-center">{record.propertyRemarks[assetIndex] || <span className="text-gray-500">-</span>}</td>
                                  </>
                                )}
                              </tr>
                            );
                          });
                        })}
                      </>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Footer count */}
          {filteredData.length > 0 && (
            <div className="bg-gray-50 px-6 py-3 border-t border-gray-200 flex justify-center">
              <div className="text-sm text-gray-600">
                {translations[language].Showing} {filteredData.length} {translations[language].Records}
                {' '}({villageKeys.length} {translations[language]?.Villages || 'villages'})
                {searchTerm && ` matching "${searchTerm}"`}
              </div>
            </div>
          )}
        </div>
        {/* ────────────────────────────────────────────────────────────────── */}
      </div>

      {/* Back / Tracking Modal */}
      <SendTrackingModal
        isOpen={showTrackingModal}
        onClose={() => setShowTrackingModal(false)}
        role={trackingRole}
        projectId={currentProjectId}
        proposalId={currentProposalId}
        translations={translations}
        language={language}
      />

      {/* Confirmation Modal */}
      {showConfirmationModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
            <div className="flex items-center mb-4">
              <div className="bg-red-100 p-2 rounded-full mr-3">
                <svg className="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8 3a1 1 0 100-2 1 1 0 000 2zm1-7H9v4h2V6z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-800">{translations[language].YouAreAboutToProceed}</h3>
            </div>
            <p className="text-sm text-gray-600 mb-6">{translations[language].DoYouReallyWantToContinuePendingSurveys}</p>
            <div className="flex justify-end gap-3">
              <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200" onClick={() => setShowConfirmationModal(false)}>{translations[language].No}</button>
              <button className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700" onClick={() => { setShowConfirmationModal(false); if (onConfirmAction) onConfirmAction(); }}>
                {translations[language].YesContinue}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && editRecord && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              {/* Header */}
              <div className="flex justify-between items-center mb-6 gap-4">
                <div className="flex flex-col flex-1">
                  <label className="text-sm font-bold text-gray-700 mb-2">{translations[language].OwnerName || 'भूधारकाचे नाव'}</label>
                  <textarea value={editRecord.owner_name || ''} onChange={e => setEditRecord({ ...editRecord, owner_name: e.target.value })} className="w-full border rounded px-2 py-1 resize-none" rows={2} disabled />
                </div>
                <div className="flex flex-col flex-1">
                  <label className="text-sm font-bold text-gray-700 mb-2">{translations[language].SurveyNo || 'गट/सर्व्हे क्रमांक'}</label>
                  <input type="text" value={editRecord.survey_no || ''} onChange={e => setEditRecord({ ...editRecord, survey_no: e.target.value })} className="w-full border rounded px-2 py-1" disabled />
                </div>
                <button onClick={() => setShowEditModal(false)} className="text-gray-400 hover:text-gray-600 mb-16"><X className="h-6 w-6" /></button>
              </div>

              {(() => {
                const visibleColumns = getVisibleColumns();
                const visibleSections = [];

                if (visibleColumns.tree) {
                  visibleSections.push(
                    <div key="tree" className="border rounded-lg p-4 bg-green-50">
                      <h4 className="font-semibold text-lg text-green-800 mb-3">
                        🌳 {selectedAgency === "agriculture" ? "फळझाडे" : selectedAgency === "forest" ? "वनझाडे" : translations[language].Tree}
                      </h4>
                      {(editRecord.tree || []).filter(tree => {
                        if (selectedAgency === "agriculture") return tree.tree_type_name1 === "फळझाडे";
                        if (selectedAgency === "forest") return tree.tree_type_name1 === "वनझाडे";
                        return true;
                      }).map(tree => {
                        const originalIdx = editRecord.tree.findIndex(t => t.tree_id === tree.tree_id);
                        const currentTree = editRecord.tree[originalIdx];
                        const countVal = currentTree.tree_count ?? "";
                        const rateVal = currentTree.tree_value_valuer ?? "";
                        return (
                          <div key={tree.tree_id} className="grid grid-cols-6 gap-3 border rounded p-3 mb-2 bg-white items-center">
                            <div className="col-span-1 font-medium">{tree.tree_type_name}</div>
                            <div className="flex flex-col">
                              <label className="text-xs text-gray-600">{translations[language].Compositenumber}</label>
                              <input type="text" value={countVal} onChange={e => { const arr = [...(editRecord.tree || [])]; arr[originalIdx] = { ...currentTree, tree_count: e.target.value }; setEditRecord({ ...editRecord, tree: arr }); }} className="w-20 border rounded px-2 py-1" disabled />
                            </div>
                            <div className="flex flex-col">
                              <label className="text-xs text-gray-600">{translations[language].Numberofactuals}</label>
                              <input type="text" value={rateVal} onChange={e => {
                                const value = e.target.value; const parsedRate = parseFloat(value); const parsedCount = parseFloat(currentTree.tree_count) || 0;
                                const arr = [...(editRecord.tree || [])];
                                if (!isNaN(parsedRate) && parsedRate > parsedCount) { alert(`❌ प्रत्यक्षांची संख्या ही संयूक्तमोजणी संख्या जास्त असू शकत नाही (${parsedCount})`); arr[originalIdx] = { ...currentTree, tree_value_valuer: rateVal }; }
                                else arr[originalIdx] = { ...currentTree, tree_value_valuer: value };
                                setEditRecord({ ...editRecord, tree: arr });
                              }} className="w-24 border rounded px-2 py-1" />
                            </div>
                            <div className="flex flex-col">
                              <label className="text-xs text-gray-600">{translations[language].Paymentdue}</label>
                              <input type="text" value={currentTree.tree_amount_valuer ?? ""} onChange={e => { const arr = [...(editRecord.tree || [])]; arr[originalIdx] = { ...currentTree, tree_amount_valuer: e.target.value }; setEditRecord({ ...editRecord, tree: arr }); }} className="w-24 border rounded px-2 py-1 font-bold text-green-700" />
                            </div>
                            <div className="flex flex-col col-span-2">
                                <label className="text-xs text-gray-600">{translations[language].Remarks}</label>
                                <input type="text" value={currentTree.remarks ?? ""} onChange={e => { const arr = [...(editRecord.tree || [])]; arr[originalIdx] = { ...currentTree, remarks: e.target.value }; setEditRecord({ ...editRecord, tree: arr }); }} className="w-full border rounded px-2 py-1" />
                            </div>
                            {tree.document && (
                              <button type="button" onClick={() => handleViewDocument(tree.document)} className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"><Eye className="h-4 w-4" /></button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  );
                }

                // Borewell
                if (visibleColumns.borewell) {
                  visibleSections.push(
                    <div key="borewell" className="border rounded-lg p-4 bg-indigo-50">
                      <h4 className="font-semibold text-lg text-indigo-800 mb-3">⚡ {translations[language].Borewell}</h4>
                      {editRecord.borewell && editRecord.borewell.length > 0 ? editRecord.borewell.map((bw, idx) => {
                        const countVal = bw.total ?? ""; const rateVal = bw.actual_area ?? ""; const totalVal = bw.Property_amount_valuer ?? ""; const yearVal = bw.year_of_construction ?? "";
                        return (
                          <div key={bw.Property_id || idx} className="border rounded p-3 mb-2 bg-white">
                            <div className="font-medium mb-3">{translations[language].Borewell} {idx + 1}</div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Depthasperjointmeasurement}</label><input type="text" value={countVal} onChange={e => { const n = [...editRecord.borewell]; n[idx] = { ...n[idx], total: e.target.value }; setEditRecord({ ...editRecord, borewell: n }); }} className="w-full border rounded px-2 py-1" disabled /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].actualDepth}</label><input type="text" value={rateVal} onChange={e => {
                                const value = e.target.value; const parsedRate = parseFloat(value); const parsedCount = parseFloat(bw.total) || 0; const n = [...editRecord.borewell];
                                if (!isNaN(parsedRate) && parsedRate > parsedCount) { alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`); n[idx] = { ...n[idx], actual_area: rateVal }; } else n[idx] = { ...n[idx], actual_area: value };
                                setEditRecord({ ...editRecord, borewell: n });
                              }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Paymentdue}</label><input type="text" value={totalVal} onChange={e => { const n = [...editRecord.borewell]; n[idx] = { ...n[idx], Property_amount_valuer: e.target.value }; setEditRecord({ ...editRecord, borewell: n }); }} className="w-full border rounded px-2 py-1 font-bold text-indigo-700" /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Yearofexcavation}</label><input type="text" value={yearVal} onChange={e => { const n = [...editRecord.borewell]; n[idx] = { ...n[idx], year_of_construction: e.target.value }; setEditRecord({ ...editRecord, borewell: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Remarks}</label><input type="text" value={bw.remarks ?? ""} onChange={e => { const n = [...editRecord.borewell]; n[idx] = { ...n[idx], remarks: e.target.value }; setEditRecord({ ...editRecord, borewell: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            {bw.document && <div className="flex justify-end mt-2"><button type="button" onClick={() => handleViewDocument(bw.document)} className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"><Eye className="h-4 w-4" /></button></div>}
                          </div>
                        );
                      }) : <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">{translations[language].NoDataAvailableForThisRecord || "No borewell data available"}</div>}
                    </div>
                  ); 
                }

                // Pipeline
                if (visibleColumns.pipeline) {
                  visibleSections.push(
                    <div key="pipeline" className="border rounded-lg p-4 bg-red-50">
                      <h4 className="font-semibold text-lg text-red-800 mb-3">🔧 {translations[language].Pipeline}</h4>
                      {editRecord.pipeline && editRecord.pipeline.length > 0 ? editRecord.pipeline.map((pipe, idx) => {
                        const countVal = pipe.total ?? ""; const rateVal = pipe.actual_area ?? ""; const totalVal = pipe.Property_amount_valuer ?? ""; const yearVal = pipe.year_of_construction ?? "";
                        return (
                          <div key={pipe.Property_id || idx} className="border rounded p-3 mb-2 bg-white">
                            <div className="font-medium mb-3">{translations[language].pipeline} {idx + 1}</div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Lengthaccordingtojointmeasurement}</label><input type="text" value={countVal} onChange={e => { const n = [...editRecord.pipeline]; n[idx] = { ...n[idx], total: e.target.value }; setEditRecord({ ...editRecord, pipeline: n }); }} className="w-full border rounded px-2 py-1" disabled /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].actuallength}</label><input type="text" value={rateVal} onChange={e => {
                                const value = e.target.value; const parsedRate = parseFloat(value); const parsedCount = parseFloat(pipe.total) || 0; const n = [...editRecord.pipeline];
                                if (!isNaN(parsedRate) && parsedRate > parsedCount) { alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`); n[idx] = { ...n[idx], actual_area: rateVal }; } else n[idx] = { ...n[idx], actual_area: value };
                                setEditRecord({ ...editRecord, pipeline: n });
                              }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Paymentdue}</label><input type="text" value={totalVal} onChange={e => { const n = [...editRecord.pipeline]; n[idx] = { ...n[idx], Property_amount_valuer: e.target.value }; setEditRecord({ ...editRecord, pipeline: n }); }} className="w-full border rounded px-2 py-1 font-bold text-red-700" /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Yearofconstruction}</label><input type="text" value={yearVal} onChange={e => { const n = [...editRecord.pipeline]; n[idx] = { ...n[idx], year_of_construction: e.target.value }; setEditRecord({ ...editRecord, pipeline: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Remarks}</label><input type="text" value={pipe.remarks ?? ""} onChange={e => { const n = [...editRecord.pipeline]; n[idx] = { ...n[idx], remarks: e.target.value }; setEditRecord({ ...editRecord, pipeline: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            {pipe.document && <div className="flex justify-end mt-2"><button type="button" onClick={() => handleViewDocument(pipe.document)} className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"><Eye className="h-4 w-4" /></button></div>}
                          </div>
                        );
                      }) : <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">{translations[language].NoDataAvailableForThisRecord || "No pipeline data available"}</div>}
                    </div>
                  );
                }

                // Home
                if (visibleColumns.home) {
                  visibleSections.push(
                    <div key="home" className="border rounded-lg p-4 bg-pink-50">
                      <h4 className="font-semibold text-lg text-pink-800 mb-3">🏠 {translations[language].Home}</h4>
                      {editRecord.home && editRecord.home.length > 0 ? editRecord.home.map((home, idx) => {
                        const countVal = home.total ?? ""; const rateVal = home.actual_area ?? ""; const totalVal = home.Property_amount_valuer ?? ""; const yearVal = home.year_of_construction ?? "";
                        return (
                          <div key={home.Property_id || idx} className="border rounded p-3 mb-2 bg-white">
                            <div className="font-medium mb-3">{translations[language].Home} {idx + 1} – {home.house_floor_no || "N/A"}</div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Areaaccordingtocombinedcalculation}</label><input type="text" value={countVal} onChange={e => { const n = [...editRecord.home]; n[idx] = { ...n[idx], total: e.target.value }; setEditRecord({ ...editRecord, home: n }); }} className="w-full border rounded px-2 py-1" disabled /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Agcactualarea}</label><input type="text" value={rateVal} onChange={e => {
                                const value = e.target.value; const parsedRate = parseFloat(value); const parsedCount = parseFloat(home.total) || 0; const n = [...editRecord.home];
                                if (!isNaN(parsedRate) && parsedRate > parsedCount) { alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`); n[idx] = { ...n[idx], actual_area: rateVal }; } else n[idx] = { ...n[idx], actual_area: value };
                                setEditRecord({ ...editRecord, home: n });
                              }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Paymentdue}</label><input type="text" value={totalVal} onChange={e => { const n = [...editRecord.home]; n[idx] = { ...n[idx], Property_amount_valuer: e.target.value }; setEditRecord({ ...editRecord, home: n }); }} className="w-full border rounded px-2 py-1 font-bold text-pink-700" /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Yearofconstruction}</label><input type="text" value={yearVal} onChange={e => { const n = [...editRecord.home]; n[idx] = { ...n[idx], year_of_construction: e.target.value }; setEditRecord({ ...editRecord, home: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Remarks}</label><input type="text" value={home.remarks ?? ""} onChange={e => { const n = [...editRecord.home]; n[idx] = { ...n[idx], remarks: e.target.value }; setEditRecord({ ...editRecord, home: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            {home.document && <div className="flex justify-end mt-2"><button type="button" onClick={() => handleViewDocument(home.document)} className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"><Eye className="h-4 w-4" /></button></div>}
                          </div>
                        );
                      }) : <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">{translations[language].NoDataAvailableForThisRecord || "No home data available"}</div>}
                    </div>
                  );
                }

                // TinShed
                if (visibleColumns.tinShed) {
                  visibleSections.push(
                    <div key="tinshed" className="border rounded-lg p-4 bg-amber-50">
                      <h4 className="font-semibold text-lg text-amber-800 mb-3">🚚 {translations[language].TinShed}</h4>
                      {editRecord["tinshed/godown"] && editRecord["tinshed/godown"].length > 0 ? editRecord["tinshed/godown"].map((shed, idx) => {
                        const countVal = shed.total ?? ""; const rateVal = shed.actual_area ?? ""; const totalVal = shed.Property_amount_valuer ?? ""; const yearVal = shed.year_of_construction ?? "";
                        return (
                          <div key={shed.Property_id || idx} className="border rounded p-3 mb-2 bg-white">
                            <div className="font-medium mb-3">{translations[language].TinShed} {idx + 1}</div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Areaaccordingtocombinedcalculation}</label><input type="text" value={countVal} onChange={e => { const n = [...editRecord["tinshed/godown"]]; n[idx] = { ...n[idx], total: e.target.value }; setEditRecord({ ...editRecord, "tinshed/godown": n }); }} className="w-full border rounded px-2 py-1" disabled /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Agcactualarea}</label><input type="text" value={rateVal} onChange={e => {
                                const value = e.target.value; const parsedRate = parseFloat(value); const parsedCount = parseFloat(shed.total) || 0; const n = [...editRecord["tinshed/godown"]];
                                if (!isNaN(parsedRate) && parsedRate > parsedCount) { alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`); n[idx] = { ...n[idx], actual_area: rateVal }; } else n[idx] = { ...n[idx], actual_area: value };
                                setEditRecord({ ...editRecord, "tinshed/godown": n });
                              }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Paymentdue}</label><input type="text" value={totalVal} onChange={e => { const n = [...editRecord["tinshed/godown"]]; n[idx] = { ...n[idx], Property_amount_valuer: e.target.value }; setEditRecord({ ...editRecord, "tinshed/godown": n }); }} className="w-full border rounded px-2 py-1 font-bold text-amber-700" /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Yearofconstruction}</label><input type="text" value={yearVal} onChange={e => { const n = [...editRecord["tinshed/godown"]]; n[idx] = { ...n[idx], year_of_construction: e.target.value }; setEditRecord({ ...editRecord, "tinshed/godown": n }); }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Remarks}</label><input type="text" value={shed.remarks ?? ""} onChange={e => { const n = [...editRecord["tinshed/godown"]]; n[idx] = { ...n[idx], remarks: e.target.value }; setEditRecord({ ...editRecord, "tinshed/godown": n }); }} className="w-full border rounded px-2 py-1" /></div>
                            {shed.document && <div className="flex justify-end mt-2"><button type="button" onClick={() => handleViewDocument(shed.document)} className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"><Eye className="h-4 w-4" /></button></div>}
                          </div>
                        );
                      }) : <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">{translations[language].NoDataAvailableForThisRecord || "No tin shed data available"}</div>}
                    </div>
                  );
                }

                // Wire
                if (visibleColumns.wire) {
                  visibleSections.push(
                    <div key="wire" className="border rounded-lg p-4 bg-blue-50">
                      <h4 className="font-semibold text-lg text-blue-800 mb-3">🪢 {translations[language].AgWirefencing}</h4>
                      {editRecord.wirefencing && editRecord.wirefencing.length > 0 ? editRecord.wirefencing.map((wire, idx) => {
                        const countVal = wire.total ?? ""; const rateVal = wire.actual_area ?? ""; const totalVal = wire.Property_amount_valuer ?? ""; const yearVal = wire.year_of_construction ?? "";
                        return (
                          <div key={wire.Property_id || idx} className="border rounded p-3 mb-2 bg-white">
                            <div className="font-medium mb-3">{translations[language].AgWirefencing} {idx + 1}</div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Areaaccordingtocombinedcalculation}</label><input type="text" value={countVal} onChange={e => { const n = [...editRecord.wirefencing]; n[idx] = { ...n[idx], total: e.target.value }; setEditRecord({ ...editRecord, wirefencing: n }); }} className="w-full border rounded px-2 py-1" disabled /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].lengthheight}</label><input type="text" value={rateVal} onChange={e => {
                                const value = e.target.value; const parsedRate = parseFloat(value); const parsedCount = parseFloat(wire.total) || 0; const n = [...editRecord.wirefencing];
                                if (!isNaN(parsedRate) && parsedRate > parsedCount) { alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`); n[idx] = { ...n[idx], actual_area: rateVal }; } else n[idx] = { ...n[idx], actual_area: value };
                                setEditRecord({ ...editRecord, wirefencing: n });
                              }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Paymentdue}</label><input type="text" value={totalVal} onChange={e => { const n = [...editRecord.wirefencing]; n[idx] = { ...n[idx], Property_amount_valuer: e.target.value }; setEditRecord({ ...editRecord, wirefencing: n }); }} className="w-full border rounded px-2 py-1 font-bold text-blue-700" /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Yearofconstruction}</label><input type="text" value={yearVal} onChange={e => { const n = [...editRecord.wirefencing]; n[idx] = { ...n[idx], year_of_construction: e.target.value }; setEditRecord({ ...editRecord, wirefencing: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Remarks}</label><input type="text" value={wire.remarks ?? ""} onChange={e => { const n = [...editRecord.wirefencing]; n[idx] = { ...n[idx], remarks: e.target.value }; setEditRecord({ ...editRecord, wirefencing: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            {wire.document && <div className="flex justify-end mt-2"><button type="button" onClick={() => handleViewDocument(wire.document)} className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"><Eye className="h-4 w-4" /></button></div>}
                          </div>
                        );
                      }) : <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">{translations[language].NoDataAvailableForThisRecord || "No wirefencing data available"}</div>}
                    </div>
                  );
                }

                // Well
                if (visibleColumns.well) {
                  visibleSections.push(
                    <div key="well" className="border rounded-lg p-4 bg-teal-50">
                      <h4 className="font-semibold text-lg text-teal-800 mb-3">⛲ {translations[language].Well}</h4>
                      {editRecord.well && editRecord.well.length > 0 ? editRecord.well.map((wl, idx) => {
                        const countVal = wl.total ?? ""; const rateVal = wl.actual_area ?? ""; const totalVal = wl.Property_amount_valuer ?? ""; const yearVal = wl.year_of_construction ?? "";
                        return (
                          <div key={wl.Property_id || idx} className="border rounded p-3 mb-2 bg-white">
                            <div className="font-medium mb-3">{translations[language].Well} {idx + 1}</div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Volumeasperjointmeasurement}</label><input type="text" value={countVal} onChange={e => { const n = [...editRecord.well]; n[idx] = { ...n[idx], total: e.target.value }; setEditRecord({ ...editRecord, well: n }); }} className="w-full border rounded px-2 py-1" disabled /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].ActualVolume}</label><input type="text" value={rateVal} onChange={e => {
                                const value = e.target.value; const parsedRate = parseFloat(value); const parsedCount = parseFloat(wl.total) || 0; const n = [...editRecord.well];
                                if (!isNaN(parsedRate) && parsedRate > parsedCount) { alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`); n[idx] = { ...n[idx], actual_area: rateVal }; } else n[idx] = { ...n[idx], actual_area: value };
                                setEditRecord({ ...editRecord, well: n });
                              }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Paymentdue}</label><input type="text" value={totalVal} onChange={e => { const n = [...editRecord.well]; n[idx] = { ...n[idx], Property_amount_valuer: e.target.value }; setEditRecord({ ...editRecord, well: n }); }} className="w-full border rounded px-2 py-1 font-bold text-teal-700" /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Yearofexcavation}</label><input type="text" value={yearVal} onChange={e => { const n = [...editRecord.well]; n[idx] = { ...n[idx], year_of_construction: e.target.value }; setEditRecord({ ...editRecord, well: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Remarks}</label><input type="text" value={wl.remarks ?? ""} onChange={e => { const n = [...editRecord.well]; n[idx] = { ...n[idx], remarks: e.target.value }; setEditRecord({ ...editRecord, well: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            {wl.document && <div className="flex justify-end mt-2"><button type="button" onClick={() => handleViewDocument(wl.document)} className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"><Eye className="h-4 w-4" /></button></div>}
                          </div>
                        );
                      }) : <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">{translations[language].NoDataAvailableForThisRecord || "No well data available"}</div>}
                    </div>
                  );
                }

                // Farmpond
                if (visibleColumns.farmpond) {
                  visibleSections.push(
                    <div key="farmpond" className="border rounded-lg p-4 bg-blue-50">
                      <h4 className="font-semibold text-lg text-blue-800 mb-3">🏞️ {translations[language].AgFarmpond}</h4>
                      {editRecord.farmpond && editRecord.farmpond.length > 0 ? editRecord.farmpond.map((pond, idx) => {
                        const countVal = pond.total ?? ""; const rateVal = pond.actual_area ?? ""; const totalVal = pond.Property_amount_valuer ?? ""; const yearVal = pond.year_of_construction ?? "";
                        return (
                          <div key={pond.Property_id || idx} className="border rounded p-3 mb-2 bg-white">
                            <div className="font-medium mb-3">{translations[language].AgFarmpond} {idx + 1}</div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Volumeasperjointmeasurement}</label><input type="text" value={countVal} onChange={e => { const n = [...editRecord.farmpond]; n[idx] = { ...n[idx], total: e.target.value }; setEditRecord({ ...editRecord, farmpond: n }); }} className="w-full border rounded px-2 py-1" disabled /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].ActualVolume}</label><input type="text" value={rateVal} onChange={e => {
                                const value = e.target.value; const parsedRate = parseFloat(value); const parsedCount = parseFloat(pond.total) || 0; const n = [...editRecord.farmpond];
                                if (!isNaN(parsedRate) && parsedRate > parsedCount) { alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`); n[idx] = { ...n[idx], actual_area: rateVal }; } else n[idx] = { ...n[idx], actual_area: value };
                                setEditRecord({ ...editRecord, farmpond: n });
                              }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Paymentdue}</label><input type="text" value={totalVal} onChange={e => { const n = [...editRecord.farmpond]; n[idx] = { ...n[idx], Property_amount_valuer: e.target.value }; setEditRecord({ ...editRecord, farmpond: n }); }} className="w-full border rounded px-2 py-1 font-bold text-blue-700" /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Yearofconstruction}</label><input type="text" value={yearVal} onChange={e => { const n = [...editRecord.farmpond]; n[idx] = { ...n[idx], year_of_construction: e.target.value }; setEditRecord({ ...editRecord, farmpond: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Remarks}</label><input type="text" value={pond.remarks ?? ""} onChange={e => { const n = [...editRecord.farmpond]; n[idx] = { ...n[idx], remarks: e.target.value }; setEditRecord({ ...editRecord, farmpond: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            {pond.document && <div className="flex justify-end mt-2"><button type="button" onClick={() => handleViewDocument(pond.document)} className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"><Eye className="h-4 w-4" /></button></div>}
                          </div>
                        );
                      }) : <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">{translations[language].NoDataAvailableForThisRecord || "No farmpond data available"}</div>}
                    </div>
                  );
                }

                // Other Asset
                if (visibleColumns.otherAsset) {
                  visibleSections.push(
                    <div key="other" className="border rounded-lg p-4 bg-purple-50">
                      <h4 className="font-semibold text-lg text-purple-800 mb-3">🛠️ {translations[language].NewOtherAsset || "Other Asset"}</h4>
                      {editRecord.other && editRecord.other.length > 0 ? editRecord.other.map((asset, idx) => {
                        const countVal = asset.total ?? asset.Property_count ?? ""; const rateVal = asset.actual_area ?? ""; const totalVal = asset.Property_amount_valuer ?? ""; const yearVal = asset.year_of_construction ?? "";
                        return (
                          <div key={asset.Property_id || idx} className="border rounded p-3 mb-2 bg-white">
                            <div className="font-medium mb-3">{translations[language].NewOtherAsset || "Other Asset"} {idx + 1}</div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Areaaccordingtocombinedcalculation}</label><input type="text" value={countVal} onChange={e => { const n = [...editRecord.other]; n[idx] = { ...n[idx], total: e.target.value }; setEditRecord({ ...editRecord, other: n }); }} className="w-full border rounded px-2 py-1" disabled /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Agcactualarea}</label><input type="text" value={rateVal} onChange={e => {
                                const value = e.target.value; const parsedRate = parseFloat(value); const parsedCount = parseFloat(asset.total || asset.Property_count) || 0; const n = [...editRecord.other];
                                if (!isNaN(parsedRate) && parsedRate > parsedCount) { alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`); n[idx] = { ...n[idx], actual_area: rateVal }; } else n[idx] = { ...n[idx], actual_area: value };
                                setEditRecord({ ...editRecord, other: n });
                              }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Paymentdue}</label><input type="text" value={totalVal} onChange={e => { const n = [...editRecord.other]; n[idx] = { ...n[idx], Property_amount_valuer: e.target.value }; setEditRecord({ ...editRecord, other: n }); }} className="w-full border rounded px-2 py-1 font-bold text-purple-700" /></div>
                              <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Yearofexcavation}</label><input type="text" value={yearVal} onChange={e => { const n = [...editRecord.other]; n[idx] = { ...n[idx], year_of_construction: e.target.value }; setEditRecord({ ...editRecord, other: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            </div>
                            <div className="flex flex-col"><label className="text-xs text-gray-600 mb-1">{translations[language].Remarks}</label><input type="text" value={asset.remarks ?? ""} onChange={e => { const n = [...editRecord.other]; n[idx] = { ...n[idx], remarks: e.target.value }; setEditRecord({ ...editRecord, other: n }); }} className="w-full border rounded px-2 py-1" /></div>
                            {asset.document && <div className="flex justify-end mt-2"><button type="button" onClick={() => handleViewDocument(asset.document)} className="px-3 py-1 bg-purple-600 text-white rounded-lg text-sm hover:bg-purple-700 flex items-center gap-1"><Eye className="h-4 w-4" /></button></div>}
                          </div>
                        );
                      }) : <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">{translations[language].NoDataAvailableForThisRecord || "No other asset data available"}</div>}
                    </div>
                  );
                }

                const gridCols = visibleSections.length === 1 ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2';
                return (
                  <div className="space-y-6">
                    <div className={`grid ${gridCols} gap-6`}>{visibleSections}</div>
                  </div>
                );
              })()}

              {/* Save Button */}
              <button
                className={`mt-6 px-6 py-2 rounded-lg text-white flex items-center justify-center gap-2 ${isSaving ? "bg-green-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"}`}
                disabled={isSaving}
                onClick={async () => {
                  try {
                    setIsSaving(true);
                    const visibleColumns = getVisibleColumns();

                    if (visibleColumns.tree && editRecord.tree?.length > 0) {
                      for (let tree of editRecord.tree) {
                        await apiService.patchUpdateTree(tree.tree_id, { tree_count: tree.tree_count, tree_value_valuer: tree.tree_value_valuer, tree_amount_valuer: tree.tree_amount_valuer, remarks: tree.remarks });
                      }
                    }   
                             const patchProp = async (items, key) => {
                       // Use the 'items' parameter here instead of editRecord[key]
                    if (visibleColumns[key] && items?.length > 0) {
                           for (let item of items) {
                             await apiService.patchUpdateProperty(item.Property_id, {  Property_value_valuer: item.Property_value_valuer,  property_type: item.property_type, Property_amount_valuer: item.Property_amount_valuer, remarks: item.remarks, year_of_construction: item.year_of_construction, actual_area: item.actual_area, ...(item.house_floor_no !== undefined ? { house_floor_no: item.house_floor_no } : {}) });
                             }
                             }
                           };
                    
                    await patchProp(editRecord.well, 'well');
                    await patchProp(editRecord.home, 'home');
                    if (visibleColumns.tinShed && editRecord["tinshed/godown"]?.length > 0) {
                      for (let shed of editRecord["tinshed/godown"]) { await apiService.patchUpdateProperty(shed.Property_id, { Property_value_valuer: shed.Property_value_valuer, property_type: shed.property_type, Property_amount_valuer: shed.Property_amount_valuer, remarks: shed.remarks, year_of_construction: shed.year_of_construction, actual_area: shed.actual_area }); }
                    }
                    await patchProp(editRecord.wirefencing, 'wire');
                    await patchProp(editRecord.farmpond, 'farmpond');
                    await patchProp(editRecord.borewell, 'borewell');
                    await patchProp(editRecord.pipeline, 'pipeline');
                    await patchProp(editRecord.other, 'otherAsset');

                    setSuccess(true); setSuccessMessage("Updated Successfully");
                    setShowEditModal(false);
                    await loadCompensationData();
                    setTimeout(() => { setSuccess(false); setSuccessMessage(''); }, 4000);
                  } catch (error) {
                    console.error("Update failed:", error);
                    setError(`${translations[language].FailedToUpdate}: ${error.message}`);
                  } finally { setIsSaving(false); }
                }}
              >
                {isSaving ? (
                  <><svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path></svg>{translations[language].Saving}...</>
                ) : (
                  <><Save className="w-5 h-5" />{translations[language].Save}</>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Document Viewer Modal */}
      {showDocumentViewer && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl w-full max-w-6xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
            <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <h3 className="text-2xl font-bold text-gray-800 tracking-tight">{translations[language]?.DocumentPreview || 'Document Preview'}</h3>
              <button onClick={closeDocumentViewer} className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 transition-all flex items-center justify-center"><X className="h-6 w-6" /></button>
            </div>
            <div className="h-[calc(95vh-80px)] flex flex-col">
              <div className="flex-1 bg-gray-50 overflow-hidden">
                <div className="w-full h-full flex items-center justify-center">
                  {isPDFToView ? (
                    <iframe src={fileUrlToView} className="w-full h-full border-0 bg-white" title="PDF Preview" />
                  ) : (
                    <img src={fileUrlToView} alt="Document" className="w-full h-auto object-contain" />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConcernValuer;